// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"229":"9d92dd39","810":"7f005b7f"}[chunkId] + ".js";
};